import {
  type UseMutationOptions,
  type UseMutationResult,
  type UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { serialize } from 'object-to-formdata';
import type {
  GetUserResponse,
  UpdatePasswordParams,
  UpdatePasswordResponse,
  UpdateUserParams,
  UpdateUserPasswordParams,
  UserResponse,
} from 'types/api/user';
import { type ApiError, faksApiInstance as api } from './api';

export const useGetUserQuery = (
  options?: Omit<UseQueryOptions<GetUserResponse, AxiosError<ApiError>>, 'queryKey' | 'queryFn'>
) =>
  useQuery<GetUserResponse, AxiosError<ApiError>>({
    queryKey: ['user/_current'],
    queryFn: () => api.get<GetUserResponse>('user/_current'),
    ...options,
  });

export const useUpdateUserMutation = (
  options?: UseMutationOptions<UserResponse, AxiosError<ApiError>, UpdateUserParams>
): UseMutationResult<UserResponse, AxiosError<ApiError>, UpdateUserParams> =>
  useMutation({
    mutationFn: (params) => api.patch<UserResponse>('user', serialize(params)),
    ...options,
  });

export const useUpdatePasswordAfterResetMutation = (
  _options?: UseMutationOptions<UpdatePasswordResponse, AxiosError<ApiError>, UpdatePasswordParams>
): UseMutationResult<UpdatePasswordResponse, AxiosError<ApiError>, UpdatePasswordParams> =>
  useMutation({
    mutationFn: (params) =>
      api.patch<UpdatePasswordResponse>('user/update_password_after_reset', params),
  });

export const useUpdateUserPasswordMutation = (
  options?: UseMutationOptions<UserResponse, AxiosError<ApiError>, UpdateUserPasswordParams>
): UseMutationResult<UserResponse, AxiosError<ApiError>, UpdateUserPasswordParams> =>
  useMutation({
    mutationFn: (params) => api.patch<UserResponse>('user/update_password', params),
    ...options,
  });
